import { get } from "svelte/store";
import { notificationData } from "../stores/data"
import { cloneDeep } from "lodash-es";

let id = 0;

let current;

export function deleteNotify(notify) {
	current.forEach((raw, i) => {
		if (raw.id == notify.id) {
			raw.hidden = true;
			notificationData.set(current);
		}
	})
}

export function addNotify(text, type) {
	current = get(notificationData);
	if (!current) current = [];
	let data = {
		id: id++,
		text: text,
		type: type,
		hidden: false
	}
	current.push(data);
	notificationData.set(current);

	let temp = cloneDeep(id);
	setTimeout(() => {
		deleteNotify(current[temp - 1])
	}, 4000);
}